import React, { useContext, useState, useEffect } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Button } from '@mui/material';
import { ConfirmContext } from './ConfirmContext';

export const ConfirmDialog: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const {
    open,
    texts: { title, description, confirmText, cancelText, loadingText },
    handlers: { onCancel, onConfirm },
    options: { tone, maxWidth },
  } = useContext(ConfirmContext);

  const handleConfirmClick = async () => {
    setLoading(true);
    await onConfirm();
  };

  useEffect(() => {
    setLoading(false);
  }, [open]);

  // Rendered at the app root with keepMounted, so its portal precedes later dialogs and would
  // lose the default same-z-index tie.
  const isPositive = tone === 'positive';

  const confirmButton = (
    <Button
      color={isPositive ? 'primary' : 'error'}
      variant="contained"
      onClick={handleConfirmClick}
      disabled={loading}
    >
      {loading ? loadingText : confirmText}
    </Button>
  );

  const cancelButton = (
    <Button variant="outlined" onClick={onCancel} disabled={loading}>
      {cancelText}
    </Button>
  );

  return (
    <Dialog open={open} keepMounted maxWidth={maxWidth} fullWidth sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}>
      <DialogTitle>
        <Box display="flex">
          <Box alignItems="center" display="flex" flex="1">
            {title}
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box marginTop="1em">
          <Typography component="div" paragraph fontWeight="bold" display="block" variant="body2">
            {/*
             * Only while open. A description can be a live view of something rather than plain
             * text -- the coupon batch confirmation subscribes to its form -- and keepMounted
             * would otherwise leave it mounted and re-rendering behind a closed dialog.
             */}
            {open && description}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" padding="1em" justifyContent="space-between" width="100%">
          {isPositive ? cancelButton : confirmButton}
          {isPositive ? confirmButton : cancelButton}
        </Box>
      </DialogActions>
    </Dialog>
  );
};
